<app-title-section></app-title-section>
<app-about-me></app-about-me>
<app-skill-set></app-skill-set>
<app-my-work-title></app-my-work-title>
<app-portfolio></app-portfolio>
<app-contact></app-contact>

 